const SENTENCE_END_MARKERS = '.?!…';
const QUOTATION_GENERIC_MARKERS = `"„'`;
const QUOTATION_CLOSE_MARKERS = '»”’';
const BRACKETS_CLOSE_MARKERS = '\\)\\]\\}>';

const WINDOW_WIDTH = 10;

export {
    SENTENCE_END_MARKERS,
    QUOTATION_GENERIC_MARKERS,
    QUOTATION_CLOSE_MARKERS,
    WINDOW_WIDTH,
    BRACKETS_CLOSE_MARKERS,
};
